import React from 'react';

import * as S from './styles';

import { Button } from '@useblu/ocean-react';

interface IActionsProps {
  loading?: boolean;
  showBackButtom?: boolean;
  submitType?: 'submit' | 'button';
  prevStep?: () => void;
  nextStep?: () => void;
  prevStepClassname?: string;
  nextStepClassname?: string;
  prevStepName?: string;
  nextStepName?: string;
  disabled?: boolean;
  showMaxiPagoLock?: boolean;
  showDivider?: boolean;
  prevButtonVariant?: 'primary' | 'secondary' | 'text';
}

const Actions: React.FC<IActionsProps> = ({
  loading = false,
  showBackButtom = false,
  submitType = 'submit',
  prevStep,
  nextStep,
  prevStepClassname = '',
  nextStepClassname = '',
  prevStepName = 'Voltar',
  nextStepName = 'Avançar',
  disabled,
  showMaxiPagoLock = true,
  showDivider = true,
  prevButtonVariant = 'secondary',
}) => (
  <S.Container>
    {showDivider && <S.CustomDivider />}
    <S.ButtonsContainer>
      {showMaxiPagoLock && (
        <S.ActionsContainer>
          <S.ShieldIcon size={18} className="icon" />
          <S.ActionText>Você está em um ambiente seguro.</S.ActionText>
        </S.ActionsContainer>
      )}
      <S.Buttons $expanded={!showMaxiPagoLock}>
        {showBackButtom && (
          <Button
            data-testid="button-back"
            variant={prevButtonVariant}
            className={`back-button ${prevStepClassname}`}
            onClick={prevStep}
          >
            {prevStepName}
          </Button>
        )}
        <Button
          data-testid="button-next"
          type={submitType}
          variant="primary"
          className={`next-button ${nextStepClassname}`}
          onClick={nextStep || undefined}
          disabled={disabled}
          loading={loading}
        >
          {nextStepName}
        </Button>
      </S.Buttons>
    </S.ButtonsContainer>
  </S.Container>
);

export default Actions;
